import { FC, PropsWithChildren, useRef } from "react";
import { QueryCache, QueryClient, QueryClientProvider as BaseQueryClientProvider } from "react-query";
import { useToast } from "module/common/hooks/useToast";
import { handleErrorMessage } from "./handleErrorMessage";
import { ApiError } from "module/api/service";

const QueryClientProvider: FC<PropsWithChildren> = ({ children }): JSX.Element => {
    const { showToast } = useToast();

    const queryClient = useRef(
        new QueryClient({
            defaultOptions: {
                queries: {
                    retry: false,
                    refetchOnWindowFocus: false,
                    staleTime: 600000,
                    retryOnMount: false,
                },
                mutations: {
                    onError: (error) => {
                        const { message, type } = handleErrorMessage(error);
                        showToast(message, { type });
                    },
                },
            },
            queryCache: new QueryCache({
                onError: (error) => {
                    // Не показуємо toast для 404 помилок (очікувані помилки, наприклад, ресурси які можуть не існувати)
                    if (error instanceof ApiError && error.status === 404) {
                        // eslint-disable-next-line no-console
                        console.debug('404 Not Found (expected):', error.url);
                        return;
                    }
                    // Не показуємо toast для 401 помилок в queryCache, оскільки вони вже обробляються в mutations.onError
                    // або через useLoad
                    if (error instanceof ApiError && error.status === 401) {
                        return;
                    }
                    const { message, type } = handleErrorMessage(error);
                    showToast(message, { type });
                },
            }),
        }),
    ).current;

    return <BaseQueryClientProvider client={queryClient}>{children}</BaseQueryClientProvider>;
};

export default QueryClientProvider;
